<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('tags') }}</span></li>
				</ul>
			</div>
		</div>

		<div id="toolbar" class="toolbar">
			<button id="table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('tag.edit') }}</a></li>
				<li><a tabindex="-1">{{ $t('tag.delete') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { TagsManager } from '@/core/administration/TagsManager'
import { Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { bindResetButton } from '@/core/input_controls/button/button'
import { removeTabindex } from '@/core/shared'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'

export default {
	name: 'GlobalTagManagement',
	metaInfo () {
		return {
			title: this.$t('tag.management')
		}
	},
	methods: {
		initTagsManager: function (action, tag, activeAttribute) {
			tagsManager.setProperties({
				action: action,
				activeAttribute: activeAttribute,
				tag: tag,

				postSaveAction: function () {
					table.initTable()
				}
			})
			tagsManager.initTagsManager(action)
		}
	},
	mounted () {
		let that = this
		window.tagsManager = new TagsManager(true)

		let tableColumns = [
			{
				'checkbox': true
			},
			{
				'title': 'name',
				'columnName': 'name',
				'attribute': 'name'
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' }
		}

		this.$store.dispatch(USER_CONFIG, 'globalTagsTable.tableState')
			.then((config) => {
				window.table = new Table('globalTagsTable', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								that.initTagsManager('edit', item, attribute)
							},
							2: function (item, attribute) {
								tagsManager.deleteTag(item, table)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								that.initTagsManager('edit', item, table.selectedAttribute)
							}
						}
					}
				)
				table.setSavedState(config)
				table.setDataUrl(window.urlContext + 'tags/load')
				table.setDataIDsUrl(window.urlContext + 'tags/ids')
				table.setDataSortUrl(window.urlContext + 'tags/sort')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG globalTagsTable', error)
			})

		$('#table_toolbar_search').bind('click', toggleSearchForm)
		$('#table_toolbar_add').click(function () {
			that.initTagsManager('create', '', '')
		})
	}
}
</script>

<style scoped>

</style>
